const positions = [
  {
    company: 'CPLC Community Schools',
    position: 'Software Developer',
    link: 'https://cplc.org/',
    daterange: 'February 2023 - Current',
    points: [
      'Served in a role similar to a Team Lead, making pivotal decisions about technology selection and architectural design.',
      'I held the primary responsibility for the direction of the product and oversaw the entire software development lifecycle.', 
    ],
  },
  {
    company: 'Galvanize with Hack Reactor',
    position: 'Software Engineer Immersive Resident',
    link: 'https://www.hackreactor.com/',
    daterange: 'August 2022 - February 2023',
    points: [
      'Provide one-on-one and small-group technical and project management guidance and support to students.',
      'Contribute to campus operational needs including but not limited to production level projects.',
    ],
  },
  {
    company: 'Rocket Mortgage LLC',
    position: 'Mortgage Banker',
    link: 'https://www.rocketmortgage.com',
    daterange: 'November 2020 - January 2022',
    points: [
      'Licensed Mortgage Loan Officer in 13 states.',
      'Responsible for loan origination and assisting a high volume number of clients in the refinance process while abiding by state and federal guidelines.',
    ],
  },
  {
    company: 'Donor Network of Arizona',
    position: 'Ocular Recovery Technician',
    link: 'https://www.dnaz.org/',
    daterange: 'June 2016 - November 2020',
    points: [
      'Responsible for but not limited to the determination of suitability for donated post-mortem tissues.',
      'Including the recovery of donated ocular tissues for transplant and research purposes.',
    ],
  },
  {
    company: 'Dignity Health, Banner Health, and MT. Graham Regional Medical Center',
    position: 'Patient Care Technician',
    link: '#',
    daterange: 'December 2010 - June 2016',
    points: [
      'Technical experience relating to charting and navigating EMR systems',
      'Other duties dependent on the scope of the hospital at time of employment.',
    ],
  },
    
];

export default positions;
